<p >
  {{header | translate}}
</p>
<div>
  <ng-content></ng-content>
</div>
